var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Ref } from 'vue-property-decorator';
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.escapeHandler = function (e) {
            if (e.key === 'Escape') {
                _this.close();
            }
        };
        _this.clickHandler = function (e) {
            if (e.target === _this.$refs.wrapperElement) {
                _this.close();
            }
        };
        return _this;
    }
    Modal.prototype.mounted = function () {
        if (this.overrideSidebar) {
            this.wrapperElement.style.left = '0px';
        }
        document.addEventListener('keydown', this.escapeHandler);
        document.addEventListener('mousedown', this.clickHandler);
        document.documentElement.classList.add('overflow-hidden');
    };
    Modal.prototype.beforeDestroy = function () {
        document.removeEventListener('keydown', this.escapeHandler);
        document.removeEventListener('mousedown', this.clickHandler);
        document.documentElement.classList.remove('overflow-hidden');
    };
    Modal.prototype.close = function () {
        document.documentElement.classList.remove('overflow-hidden');
        this.$emit('close');
    };
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], Modal.prototype, "overrideSidebar", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", Object)
    ], Modal.prototype, "wrapperElement", void 0);
    Modal = __decorate([
        Component
    ], Modal);
    return Modal;
}(Vue));
export default Modal;
